<div>
  <rk-form-field class="mt-3 relative" [showError]="appNameInput.invalid && appNameInput.touched">
    <input
      type="text"
      [(ngModel)]="appName"
      (ngModelChange)="validateAppName()"
      (input)="onNameInput($event)"
      #appNameInput="ngModel"
      required
      (blur)="logEvent()"
      maxlength="30"
      placeholder="{{ 'create-app-form.name-placeholder' | translate }}"
      [class.grey-background]="greyBackground"
      [class.small]="small"
    />
    <!-- error message -->
    <div class="absolute top-[62px]">
      @if (appNameInput.errors?.['required'] && appNameInput.touched) {
        <div class="form-error-message !mt-0">
          {{ 'create-app-form.missing-name' | translate }}
        </div>
      }
      @if (appNameInput.errors?.['lengthAfterTrim'] && !appNameInput.errors?.['required'] && appNameInput.touched) {
        <div class="form-error-message !mt-0">
          {{ 'create-app-form.min-length' | translate }}
        </div>
      }
      @if (appNameInput.errors?.['maxlength']) {
        <div class="form-error-message !mt-0">
          {{ 'create-app-form.max-length' | translate }}
        </div>
      }
      @if (appNameInput.errors?.['noEmoji'] && appNameInput?.value?.length > 2) {
        <div class="form-error-message !mt-0">
          {{ 'create-app-form.no-emojis' | translate }}
        </div>
      }
      @if (appNameInput.errors?.['noSpaceOnly'] && appNameInput?.value?.length > 2) {
        <div class="form-error-message !mt-0">
          {{ 'create-app-form.no-spaces-only' | translate }}.
        </div>
      }
      @if (appNameInput?.value?.length > 2 && (typedAppNameIsAvailable$ | async) === false) {
        <div class="form-error-message !mt-0">
          {{ 'create-app-form.unavailable-name' | translate }}
        </div>
      }
    </div>
  </rk-form-field>
</div>
